import INTEGRATIONS from "@/components/atomic/pages/integrations/locale/ptBR";

export default {
  ...INTEGRATIONS,
};
